/* eslint-disable */ /**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 * instead, edit its related `.gql` file and recreate it with
 *
 * npm run codegen:pensieve
 */

import * as Types from '../../types/pensieve';

import { api } from 'app/apis/pensieve-gql-api';
export type MentorDash_FetchQueueAssignmentsQueryVariables = Types.Exact<{ [key: string]: never }>;

export type MentorDash_FetchQueueAssignmentsQuery = {
  __typename?: 'Query';
  queue?: {
    __typename?: 'Queue';
    assigned: Array<{
      __typename?: 'QueueAssignment';
      atRisk?: boolean | null;
      expiresAt?: any | null;
      opportunity: {
        __typename?: 'QueueOpportunity';
        project: { __typename?: 'QueueProject'; projectID: string; title: string };
        answerPayment: { __typename?: 'Money'; amount: any; currencyCode?: string | null };
        commentPayment: { __typename?: 'Money'; amount: any; currencyCode?: string | null };
      };
      question?: { __typename?: 'Question'; id: any; link?: string | null } | null;
    }>;
  } | null;
};

export const MentorDash_FetchQueueAssignmentsDocument = `
    query MentorDash_FetchQueueAssignments {
  queue {
    assigned {
      atRisk
      expiresAt
      opportunity {
        project {
          projectID
          title
        }
        answerPayment {
          amount
          currencyCode
        }
        commentPayment {
          amount
          currencyCode
        }
      }
      question {
        id
        link
      }
    }
  }
}
    `;

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    MentorDash_FetchQueueAssignments: build.query<
      MentorDash_FetchQueueAssignmentsQuery,
      MentorDash_FetchQueueAssignmentsQueryVariables | void
    >({
      query: (variables) => ({ document: MentorDash_FetchQueueAssignmentsDocument, variables }),
    }),
  }),
});

export { injectedRtkApi as api };
